var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinusoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70567 6.00404C2.99468 7.97901 2.75 10.3858 2.75 12C2.75 12.4142 2.41421 12.75 2 12.75C1.58579 12.75 1.25 12.4142 1.25 12C1.25 10.2808 1.50532 7.68766 2.29433 5.49596C3.0635 3.3594 4.48559 1.25 7 1.25C9.51441 1.25 10.9365 3.3594 11.7057 5.49596C12.4947 7.68766 12.75 10.2808 12.75 12C12.75 13.6142 12.9947 16.021 13.7057 17.996C14.4365 20.0261 15.5144 21.25 17 21.25C18.4856 21.25 19.5635 20.0261 20.2943 17.996C21.0053 16.021 21.25 13.6142 21.25 12C21.25 11.5858 21.5858 11.25 22 11.25C22.4142 11.25 22.75 11.5858 22.75 12C22.75 13.7192 22.4947 16.3123 21.7057 18.504C20.9365 20.6406 19.5144 22.75 17 22.75C14.4856 22.75 13.0635 20.6406 12.2943 18.504C11.5053 16.3123 11.25 13.7192 11.25 12C11.25 10.3858 11.0053 7.97901 10.2943 6.00404C9.5635 3.97393 8.48559 2.75 7 2.75C5.51441 2.75 4.4365 3.97393 3.70567 6.00404Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H9C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinusoid);
export default __webpack_public_path__ + "static/media/sinusoid.d0459beecda6832d86e898559ac4e035.svg";
export { ForwardRef as ReactComponent };